import { action } from 'satcheljs';
import type { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type { ClientItemId } from 'owa-client-ids';

export const openInCompose = action(
    'openInCompose',
    (
        entrySource: FullComposeEntrySourceType,
        itemId: ClientItemId,
        formId: string,
        eventScope?: EventScope,
        eventUpdates?: Partial<CalendarEvent>,
        targetWindow?: Window
    ) => ({ entrySource, itemId, formId, eventScope, eventUpdates, targetWindow })
);
